/**
 * Breakpoint Utility
 * Uses body:before to grab the current breakpoint
 * and prints that breakpoint to a data attribute.
 * @see styles/style.scss
 */

const target = document.getElementsByTagName("body")[0];

const set = () => {
	let value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
	target.dataset.breakpoint = value;
}

const get = () => {
	return target.getAttribute('data-breakpoint');
}

export default {
	set: set,
	get: get,
	resize: () => {
		window.addEventListener("resize", set);
	}
}
